// Shared filter constants + helpers for admin dashboard tabs.

export const BOOKING_FILTER_FIELDS_OPTIONS = {
    SERVICE_KEY: [
        { value: "free_consultation", label: "Free consultation" },
        { value: "paid_consultation", label: "Paid consultation" },
        { value: "shortlisting", label: "Shortlisting" },
        { value: "viewing_on_behalf", label: "Viewing on behalf" },
        { value: "move_day_2h", label: "Move-day 2h" },
        { value: "move_day_4h", label: "Move-day 4h" },
        { value: "move_day_6h", label: "Move-day 6h" },
        { value: "move_day_8h", label: "Move-day 8h" },
        { value: "move_day_10h", label: "Move-day 10h" },
        { value: "packing_support", label: "Packing support" },
        { value: "cleaning_support", label: "Cleaning support" },
        { value: "vendor_coordination", label: "Vendor coordination" },
        { value: "landlord_connection", label: "Landlord connection" },
    ],
    // Includes system-set + admin-set statuses so admins can filter anything.
    BOOKING_STATUS: [
        { value: "received", label: "Received" },
        { value: "pending", label: "Pending" },
        { value: "pending_payment", label: "Pending payment" },
        { value: "quote_requested", label: "Quote requested" },
        { value: "confirmed", label: "Confirmed" },
        { value: "rescheduled", label: "Rescheduled" },
        { value: "completed", label: "Completed" },
        { value: "cancelled", label: "Cancelled" },
    ],
    PAYMENT_STATUS: [
        { value: "paid", label: "Paid" },
        { value: "initiated", label: "Initiated" },
        { value: "not_required", label: "Not required" },
        { value: "expired", label: "Expired" },
    ],
};

export const EMPTY_BOOKING_FILTERS = {
    q: "",
    service_key: "",
    status: "",
    payment_status: "",
    date_from: "",
    date_to: "",
};

export const EMPTY_BASIC_FILTERS = { q: "", date_from: "", date_to: "" };

export function matchesText(haystack, needle) {
    if (!needle) return true;
    const n = needle.trim().toLowerCase();
    if (!n) return true;
    return haystack.some((v) => (v || "").toString().toLowerCase().includes(n));
}

export function withinDateRange(value, from, to) {
    if (!value) return !from && !to;
    if (from && value < from) return false;
    if (to && value > to) return false;
    return true;
}
